/*
 * @Description: 
 * @Autor: soul(佘家骏) 
 * @Date: 2022-07-19 17:01:26
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-07-20 11:14:45
 */
export default {
  name: "turntable",
  imgDir: "planting",
};
